var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-0 pt-2"
  }, [_c('div', [_c('div', {
    staticClass: "flex w-full mt-2"
  }, [_c('QuarantineLevelCard', {
    staticClass: "w-full mr-6",
    attrs: {
      "user": _vm.user,
      "quarantine": _vm.quarantine,
      "payout": _vm.currentPayout
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('YButton', {
    staticClass: "mt-16",
    attrs: {
      "color": "red",
      "is-loading": _vm.isDeleting
    },
    on: {
      "click": function ($event) {
        return _vm.deleteQuarantine(_vm.quarantine.id);
      }
    }
  }, [_vm._v("Remove Quarantine")])], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }